import { api } from '../client';

export interface AuditLog {
  id: string;
  userId: string;
  user: {
    id: string;
    email: string;
    fullName: string;
  };
  companyId: string;
  action: string;
  resource: string;
  accessCode: string;
  result: 'ALLOW' | 'DENY';
  conditionsEvaluated?: Record<string, unknown>;
  ipAddress?: string;
  userAgent?: string;
  timestamp: string;
}

export interface QueryAuditLogParams {
  userId?: string;
  companyId?: string;
  action?: string;
  resource?: string;
  result?: 'ALLOW' | 'DENY';
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export const auditLogsApi = {
  async getAll(params?: QueryAuditLogParams) {
    const response = await api.get<{
      data: AuditLog[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    }>('/audit-logs', { params });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<AuditLog>(`/audit-logs/${id}`);
    return response.data;
  },
};
